import {TableFilter} from '../api/table-filter';
import {OrdersTradesTableRequest} from './orders-trades-table-request';

export class OrdersTradesFilter {

  stateFilter: OrdersTradesFilter.StateFilter = OrdersTradesFilter.StateFilter.UNALLOCATED;

  tradeFilters: TableFilter[];
  orderFilters: TableFilter[];

  public static toTradeRequest(filter: OrdersTradesFilter, request: OrdersTradesTableRequest): OrdersTradesTableRequest {
    request.stateFilter = filter.stateFilter;
    request.filters.push(...filter.tradeFilters);
    return request;
  }

  public static toOrderRequest(filter: OrdersTradesFilter, request: OrdersTradesTableRequest): OrdersTradesTableRequest {
    request.stateFilter = filter.stateFilter;
    request.filters.push(...filter.orderFilters);
    return request;
  }
}

export module OrdersTradesFilter {
  export enum StateFilter {
    ALL = 'ALL',
    UNALLOCATED = 'UNALLOCATED',
    NON_GIVEUP = 'NON_GIVEUP',
    CLEARED = 'CLEARED',
    ACCEPTED = 'ACCEPTED',
    GIVEUP = 'GIVEUP',
    REJECTED = 'REJECTED'
  }
}
